'use client';

import { ListIcon, UserIcon, XIcon } from '@phosphor-icons/react';

import { Suspense, useState } from 'react';

import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerHeader,
	DrawerTitle,
} from '@/components/ui/drawer';
import LanguageButton from './LanguageButton.tsx';
import { Navigation } from './Navigation.tsx';

const TopBar = () => {
	const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

	return (
		<div className=' py-3 gap-3 flex justify-end text-[#414141]'>
			<button
				className='mr-auto md:hidden'
				onClick={() => setIsMobileNavOpen(true)}
			>
				<ListIcon size={32} />
			</button>
			<Suspense fallback={<div>Loading...</div>}>
				<LanguageButton />
			</Suspense>
			<button>
				<UserIcon size={32} />
			</button>

			<Drawer open={isMobileNavOpen} direction='left'>
				<DrawerContent>
					<DrawerHeader>
						<DrawerTitle></DrawerTitle>
						<DrawerDescription></DrawerDescription>
						<button
							className='ml-auto'
							onClick={() => setIsMobileNavOpen(false)}
						>
							<XIcon size={32} />
						</button>
					</DrawerHeader>
					<div className='p-4 pb-0'>
						<Suspense fallback={<div>Loading...</div>}>
							<Navigation />
						</Suspense>
					</div>
				</DrawerContent>
			</Drawer>
		</div>
	);
};
export { TopBar };
